import { render, staticRenderFns } from "./showV5.vue?vue&type=template&id=7be8f3bf&"
import script from "./showV5.vue?vue&type=script&lang=js&"
export * from "./showV5.vue?vue&type=script&lang=js&"
import style0 from "./showV5.vue?vue&type=style&index=0&id=7be8f3bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports